"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForthSection = void 0;
const react_1 = __importStar(require("react"));
const ForthSection_elements_1 = require("./ForthSection.elements");
const sign_in_svg_1 = __importDefault(require("@components/icons/landing/sign-in.svg"));
const sort_svg_1 = __importDefault(require("@components/icons/landing/sort.svg"));
const checklist_svg_1 = __importDefault(require("@components/icons/landing/checklist.svg"));
const star_svg_1 = __importDefault(require("@components/icons/landing/star.svg"));
const badge_svg_1 = __importDefault(require("@components/icons/landing/badge.svg"));
const grow_chart_svg_1 = __importDefault(require("@components/icons/landing/grow-chart.svg"));
const landing_line_360_svg_1 = __importDefault(require("../../../../../../assets/svg/landing/landing-line-360.svg"));
const landing_line_768_svg_1 = __importDefault(require("../../../../../../assets/svg/landing/landing-line-768.svg"));
const landing_line_1000_svg_1 = __importDefault(require("../../../../../../assets/svg/landing/landing-line-1000.svg"));
const landing_line_1300_svg_1 = __importDefault(require("../../../../../../assets/svg/landing/landing-line-1300.svg"));
const landing_line_1690_svg_1 = __importDefault(require("../../../../../../assets/svg/landing/landing-line-1690.svg"));
const landing_line_1920_svg_1 = __importDefault(require("../../../../../../assets/svg/landing/landing-line-1920.svg"));
const Landing_1 = require("@app/routes/Landing");
const ForthSection_translations_1 = require("./ForthSection.translations");
const InfoPopUp_1 = require("../InfoPopUp");
const ForthSection = ({}) => {
    const language = (0, react_1.useContext)(Landing_1.LanguageContext);
    const t = ForthSection_translations_1.translations[language];
    let isUserAuth = 'True';
    let isTherapist = 'True';
    const [infoPopUp, setInfoPopUp] = (0, react_1.useState)(null);
    const closePopUp = () => setInfoPopUp(null);
    const openPopUp = (message) => setInfoPopUp({ message: message });
    return (react_1.default.createElement(ForthSection_elements_1.ForthSectionWrap, null,
        react_1.default.createElement("div", { className: "landing-forth-section-step landing-forth-section-step-1 landing-forth-section-left" },
            react_1.default.createElement("div", { className: "landing-forth-section-step-description" },
                react_1.default.createElement("div", { className: "landing-forth-section-step-description-content" },
                    react_1.default.createElement(sign_in_svg_1.default, null),
                    react_1.default.createElement("p", null, t["1"].info.p)),
                react_1.default.createElement("div", { className: "landing-forth-section-step-buttons" },
                    react_1.default.createElement("a", { href: "/registration?q=patient" },
                        react_1.default.createElement("button", null, t["1"].info.buttons["1"])),
                    react_1.default.createElement("a", { href: "/registration?q=therapist" },
                        react_1.default.createElement("button", null, t["1"].info.buttons["2"])))),
            react_1.default.createElement("div", { className: "landing-forth-section-step-number" }, t["1"].step)),
        react_1.default.createElement("div", { className: "landing-forth-section-step landing-forth-section-step-2 landing-forth-section-right" },
            react_1.default.createElement("div", { className: "landing-forth-section-step-description" },
                react_1.default.createElement("div", { className: "landing-forth-section-step-description-content" },
                    react_1.default.createElement(sort_svg_1.default, null),
                    react_1.default.createElement("p", null, t["2"].info.p)),
                react_1.default.createElement("div", { className: "landing-forth-section-step-buttons" },
                    react_1.default.createElement("a", { href: "/exercises/calibrate" },
                        react_1.default.createElement("button", null, t["2"].info.buttons["1"])))),
            react_1.default.createElement("div", { className: "landing-forth-section-step-number" }, t["2"].step)),
        react_1.default.createElement("div", { className: "landing-forth-section-step landing-forth-section-step-3 landing-forth-section-left" },
            react_1.default.createElement("div", { className: "landing-forth-section-step-description" },
                react_1.default.createElement("div", { className: "landing-forth-section-step-description-content" },
                    react_1.default.createElement(checklist_svg_1.default, null),
                    react_1.default.createElement("p", null, t["3"].info.p)),
                react_1.default.createElement("div", { className: "landing-forth-section-step-buttons" }, 
                // @ts-ignore
                isTherapist === "True" ? (react_1.default.createElement("button", { onClick: () => openPopUp(t["3"].info.popUpMessage) }, t["3"].info.buttons["1"])) : (react_1.default.createElement("a", { href: 
                    // @ts-ignore
                    isUserAuth === "True" ? "/profile?q=ipoc" : "/registration" },
                    react_1.default.createElement("button", null, t["3"].info.buttons["1"]))))),
            react_1.default.createElement("div", { className: "landing-forth-section-step-number" }, t["3"].step)),
        react_1.default.createElement("div", { className: "landing-forth-section-step landing-forth-section-step-4 landing-forth-section-right" },
            react_1.default.createElement("div", { className: "landing-forth-section-step-description" },
                react_1.default.createElement("div", { className: "landing-forth-section-step-description-content" },
                    react_1.default.createElement(star_svg_1.default, null),
                    react_1.default.createElement("p", null, t["4"].info.p))),
            react_1.default.createElement("div", { className: "landing-forth-section-step-number" }, t["4"].step)),
        react_1.default.createElement("div", { className: "landing-forth-section-step landing-forth-section-step-5 landing-forth-section-left" },
            react_1.default.createElement("div", { className: "landing-forth-section-step-description" },
                react_1.default.createElement("div", { className: "landing-forth-section-step-description-content" },
                    react_1.default.createElement(badge_svg_1.default, null),
                    react_1.default.createElement("p", null, t["5"].info.p))),
            react_1.default.createElement("div", { className: "landing-forth-section-step-number" }, t["5"].step)),
        react_1.default.createElement("div", { className: "landing-forth-section-step landing-forth-section-step-6 landing-forth-section-right" },
            react_1.default.createElement("div", { className: "landing-forth-section-step-description" },
                react_1.default.createElement("div", { className: "landing-forth-section-step-description-content" },
                    react_1.default.createElement(grow_chart_svg_1.default, null),
                    react_1.default.createElement("p", null, t["6"].info.p)),
                react_1.default.createElement("div", { className: "landing-forth-section-step-buttons" }, 
                // @ts-ignore
                isTherapist === "True" ? (react_1.default.createElement("button", { onClick: () => openPopUp(t["6"].info.popUpMessage) }, t["6"].info.buttons["1"])) : (react_1.default.createElement("a", { href: 
                    // @ts-ignore
                    isUserAuth === "True"
                        ? "/profile/?q=dashboard"
                        : "/registration" },
                    react_1.default.createElement("button", null, t["6"].info.buttons["1"]))))),
            react_1.default.createElement("div", { className: "landing-forth-section-step-number" }, t["6"].step)),
        react_1.default.createElement("div", { className: "landing-forth-section-line" },
            react_1.default.createElement(landing_line_360_svg_1.default, null),
            react_1.default.createElement(landing_line_768_svg_1.default, null),
            react_1.default.createElement(landing_line_1000_svg_1.default, null),
            react_1.default.createElement(landing_line_1300_svg_1.default, null),
            react_1.default.createElement(landing_line_1690_svg_1.default, null),
            react_1.default.createElement(landing_line_1920_svg_1.default, null)),
        infoPopUp && (react_1.default.createElement(InfoPopUp_1.InfoPopUp, { onClose: closePopUp }, infoPopUp.message))));
};
exports.ForthSection = ForthSection;
